/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Taggroups_Event1Inputs */

const id_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const ms_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const da_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begivenhed`)
};

const de_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis`)
};

const en_us2_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const es_es2_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const es_mx2_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const fil_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaganapan`)
};

const fr_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement`)
};

const it_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const hu_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esemény`)
};

const nl_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement`)
};

const no_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const pl_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenie`)
};

const pt_br2_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const pt_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento`)
};

const ro_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eveniment`)
};

const fi_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapahtuma`)
};

const sv_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenemang`)
};

const vi_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự kiện`)
};

const tr_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik`)
};

const cs_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Událost`)
};

const bg_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Събитие`)
};

const ru_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие`)
};

const uk_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подія`)
};

const ar_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث`)
};

const hi_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईवेंट`)
};

const th_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเวนต์`)
};

const ja_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント`)
};

const zh_cn2_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动`)
};

const zh_hant1_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活動`)
};

const ko_search_taggroups_event1 = /** @type {(inputs: Search_Taggroups_Event1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트`)
};

/**
* | output |
* | --- |
* | "Event" |
*
* @param {Search_Taggroups_Event1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_taggroups_event1 = /** @type {((inputs?: Search_Taggroups_Event1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Taggroups_Event1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_taggroups_event1(inputs)
	if (locale === "ms") return ms_search_taggroups_event1(inputs)
	if (locale === "da") return da_search_taggroups_event1(inputs)
	if (locale === "de") return de_search_taggroups_event1(inputs)
	if (locale === "en-US") return en_us2_search_taggroups_event1(inputs)
	if (locale === "es-ES") return es_es2_search_taggroups_event1(inputs)
	if (locale === "es-MX") return es_mx2_search_taggroups_event1(inputs)
	if (locale === "fil") return fil_search_taggroups_event1(inputs)
	if (locale === "fr") return fr_search_taggroups_event1(inputs)
	if (locale === "it") return it_search_taggroups_event1(inputs)
	if (locale === "hu") return hu_search_taggroups_event1(inputs)
	if (locale === "nl") return nl_search_taggroups_event1(inputs)
	if (locale === "no") return no_search_taggroups_event1(inputs)
	if (locale === "pl") return pl_search_taggroups_event1(inputs)
	if (locale === "pt-BR") return pt_br2_search_taggroups_event1(inputs)
	if (locale === "pt") return pt_search_taggroups_event1(inputs)
	if (locale === "ro") return ro_search_taggroups_event1(inputs)
	if (locale === "fi") return fi_search_taggroups_event1(inputs)
	if (locale === "sv") return sv_search_taggroups_event1(inputs)
	if (locale === "vi") return vi_search_taggroups_event1(inputs)
	if (locale === "tr") return tr_search_taggroups_event1(inputs)
	if (locale === "cs") return cs_search_taggroups_event1(inputs)
	if (locale === "bg") return bg_search_taggroups_event1(inputs)
	if (locale === "ru") return ru_search_taggroups_event1(inputs)
	if (locale === "uk") return uk_search_taggroups_event1(inputs)
	if (locale === "ar") return ar_search_taggroups_event1(inputs)
	if (locale === "hi") return hi_search_taggroups_event1(inputs)
	if (locale === "th") return th_search_taggroups_event1(inputs)
	if (locale === "ja") return ja_search_taggroups_event1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_taggroups_event1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_taggroups_event1(inputs)
	return ko_search_taggroups_event1(inputs)
});
export { search_taggroups_event1 as "search.tagGroups.event" }